import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Signal, ViewChild} from '@angular/core';
import {CoreService} from "../../../services/core.service";
import {ProjectsService} from "../../../services/projects.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent {
  currentyear: number = new Date().getFullYear(); //TODO: @Roland ich denke das brauchen wir nicht

  @Output() windowResize = new EventEmitter();
  @Output() loaded = new EventEmitter();
  @Input() loading: boolean | Signal<void> = true;
  @Input() color = 'text-light-emphasis';

  @ViewChild('footerOuterWrap') elementView: ElementRef = {} as ElementRef;

  constructor(
    private coreService: CoreService,
    private projectService: ProjectsService,
    private toastrService: ToastrService
  ) {
  }

  testToastr() {
    this.toastrService.success('This is a test toast message!', 'Test', {
      timeOut: 3000,
      positionClass: 'toast-top-right',
      progressBar: true,
      closeButton: true
    });
  }

  getGDPRLink() {
    return this.projectService.gdprLink;
  }
}
